/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Sports15Inputs */

const en__field__enum_teachingsubjectinterest_subject_sports15 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Sports15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports`)
};

const de__field__enum_teachingsubjectinterest_subject_sports15 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Sports15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport`)
};

/**
* | output |
* | --- |
* | "Sports" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Sports15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_sports15 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Sports15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Sports15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_sports15(inputs)
	return de__field__enum_teachingsubjectinterest_subject_sports15(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_sports15 as "_field__enum_teachingSubjectInterest_SUBJECT_SPORTS" }